import React, { createContext, useContext, useEffect, useState } from 'react';
import { ICurrentUser } from '../models/interface/user';
import authService from '../services/useCases/auth';

interface IState {
  isAuthenticated: boolean;
  user: any;
  isGPID: boolean;
  loading: boolean;
  login: (email: string, password: string) => Promise<ICurrentUser | null>;
  loginWithGPID: (gpid: string) => Promise<ICurrentUser | null>;
  logout: () => void;
}

interface IProps {
  children?: JSX.Element | JSX.Element[];
}

const AuthContext = createContext({} as IState);

export const AuthProvider = ({ children }: IProps) => {
  const [user, setUser] = useState<ICurrentUser>();
  const [loading, setLoading] = useState(true);
  const [isGPID, setIsGPID] = useState(false);

  useEffect(() => {
    async function loadUserFromCookies() {
      const [user, isGPID] = authService.getUserFromToken();
      if (user) {
        setUser(user);
        setIsGPID(isGPID);
      };
      setLoading(false);
    }
    loadUserFromCookies();
  }, []);

  const login = async (email: string, password: string) => {
    const user = await authService.login(email, password);
    if (user) setUser(user);
    return user;
  };

  const loginWithGPID = async (gpid: string) => {
    const user = await authService.loginWithGPID(gpid);
    if (user) {
      setUser(user);
      setIsGPID(true)
    };
    return user;
  };

  const logout = () => {
    authService.logout();
    setUser(undefined);
    setIsGPID(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!user,
        user,
        isGPID,
        login,
        loading,
        logout,
        loginWithGPID,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
